var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo, useState } from "react";
import { RadixAlertDialogue } from "../primitives/RadixAlertDialogue";
import { StoreMapEmbed } from "../storeMapEmbed";
import { acknowledgeStore, evaluateDistantLocationWarning, formatApproximateDistanceMiles, } from "./locationWarning";
import "../ui.css";
import "./distantLocationWarning.css";
var orderingWindow = window;
var TERMLY_CONSENT_BANNER_SELECTOR = '[data-termly-part="consent-banner"]';
var getSessionStorage = function () {
    try {
        return window.sessionStorage;
    }
    catch (error) {
        return null;
    }
};
var fetchApproximateLocation = function () { return __awaiter(void 0, void 0, Promise, function () {
    var response, payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, orderingWindow.fetch("".concat(orderingWindow.relativeURI(), "/location/approximate/api"), {
                    cache: "no-store",
                    credentials: "same-origin",
                    headers: { Accept: "application/json" },
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                payload = _a.sent();
                return [2 /*return*/, payload.location || null];
        }
    });
}); };
var isTermlyConsentBannerVisible = function () {
    var consentBanner = document.querySelector(TERMLY_CONSENT_BANNER_SELECTOR);
    if (!consentBanner || consentBanner.getClientRects().length === 0) {
        return false;
    }
    var computedStyle = window.getComputedStyle(consentBanner);
    return computedStyle.visibility !== "hidden" && computedStyle.opacity !== "0";
};
export var DistantLocationWarning = function () {
    var _a;
    var store = (_a = orderingWindow.session) === null || _a === void 0 ? void 0 : _a.store;
    var sessionStorage = useMemo(getSessionStorage, []);
    var _b = useState(null), distanceMiles = _b[0], setDistanceMiles = _b[1];
    var _c = useState(false), isConsentBannerVisible = _c[0], setIsConsentBannerVisible = _c[1];
    useEffect(function () {
        var scheduledUpdate = null;
        var updateConsentBannerVisibility = function () {
            setIsConsentBannerVisible(isTermlyConsentBannerVisible());
        };
        var scheduleVisibilityUpdate = function () {
            if (scheduledUpdate !== null) {
                return;
            }
            scheduledUpdate = window.requestAnimationFrame(function () {
                scheduledUpdate = null;
                updateConsentBannerVisibility();
            });
        };
        updateConsentBannerVisibility();
        var observer = new MutationObserver(scheduleVisibilityUpdate);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["aria-hidden", "data-termly-part", "hidden", "style"],
            childList: true,
            subtree: true,
        });
        return function () {
            observer.disconnect();
            if (scheduledUpdate !== null) {
                window.cancelAnimationFrame(scheduledUpdate);
            }
        };
    }, []);
    useEffect(function () {
        var isMounted = true;
        evaluateDistantLocationWarning({
            hostname: window.location.hostname,
            store: store,
            sessionStorage: sessionStorage,
            geolocation: window.navigator.geolocation,
            fetchIpCoordinates: fetchApproximateLocation,
        }).then(function (warning) {
            if (isMounted && warning) {
                setDistanceMiles(warning.distanceMiles);
            }
        }).catch(function () {
            // This optional safety check always fails open.
        });
        return function () {
            isMounted = false;
        };
    }, [sessionStorage, store === null || store === void 0 ? void 0 : store.id, store === null || store === void 0 ? void 0 : store.latitude, store === null || store === void 0 ? void 0 : store.longitude]);
    if (!store || distanceMiles === null || isConsentBannerVisible) {
        return null;
    }
    var locatorPath = store.is_catering ? "/catering/locator" : "/locator";
    var roundedDistanceMiles = formatApproximateDistanceMiles(distanceMiles);
    return (React.createElement(RadixAlertDialogue, { open: true, onOpenChange: function (open) {
            if (!open) {
                setDistanceMiles(null);
            }
        }, title: "Is this the right location?", description: (React.createElement(React.Fragment, null,
            store.name,
            " is approximately ",
            React.createElement("strong", null,
                roundedDistanceMiles,
                " miles"),
            " from you. We want to make sure you meant to order from this location.")), cancelText: "Order From This Location Anyway", onCancel: function () { return acknowledgeStore(sessionStorage, store.id); }, actionText: "Find a Closer Location", onAction: function () { return window.location.assign(locatorPath); }, overlayClassName: "radix-alert-dialog-overlay distant-location-warning-overlay", contentClassName: "radix-alert-dialog-content distant-location-warning" },
        React.createElement(StoreMapEmbed, { name: store.name, address: store.address, city: store.city, state: store.state, zip: store.zip, className: "distant-location-warning-map" })));
};
